import styled from 'styled-components';

/** How strong the bloom round the star shows: full in dark, softer on a light page, where a full bloom reads as a
 *  stain round the star. */
const BLOOM_OPACITY = { dark: 1, light: 0.55 } as const;

/**
 * Block-level and non-shrinking, like the static LumioMark. The star's side tips reach half a unit past its 24-unit
 * box: they show whole.
 */
export const Svg = styled.svg<{ $size: number }>`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  display: block;
  flex: 0 0 auto;
  overflow: visible;
`;

/** The bloom under the star: a static group (only the lights it mirrors move), its strength per theme. */
export const Bloom = styled.g`
  opacity: ${BLOOM_OPACITY.dark};

  :root[data-ows-theme='light'] & {
    opacity: ${BLOOM_OPACITY.light};
  }
`;
